import { createSelector } from 'reselect'
import { INotifications } from '../types/notifications'
import { AppStateType } from '../reducers'

export const selectNotifications = createSelector(
  [(state: AppStateType) => state.notifications],
  (notifications: INotifications): INotifications => notifications
)
